module.exports = __webpack_public_path__ + "231c1d8805bbdcb2714a7682e3cdd128.svg";